interface ColoredLogoProps {
  src: string;
  color?: string;
  size?: number;
  className?: string;
  ariaLabel?: string;
}

const ColoredLogo = ({
  src,
  color = "currentColor",
  size = 48,
  className = "",
  ariaLabel = "brand logo",
}: ColoredLogoProps) => {
  const maskUrl = `url("${src}")`;

  return (
    <span
      role="img"
      aria-label={ariaLabel}
      className={`inline-block flex-shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: color,
        maskImage: maskUrl,
        WebkitMaskImage: maskUrl,
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskPosition: "center",
        WebkitMaskPosition: "center",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
      }}
    />
  );
};

export default ColoredLogo;
